import React, { useEffect, useState } from "react";
import { Oval } from 'react-loader-spinner';
import "./vendor.css";
import { useNavigate } from "react-router-dom";
import { baseurl } from "../CoocpeatHome";
import axios from "axios";
import Cookies from "js-cookie";

const Vendor = ({ searchTerm }) => {
    const [vendors, setVendors] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const fetchVendors = async () => {
        try {
            setLoading(true);
            const res = await axios.get(baseurl + "admin/getVendor", {
                params: {
                    userId: Cookies.get("userId")
                }
            });
            setVendors(res.data.vendors);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVendors();
    }, []);

    const handleExplore = (id) => {
        navigate('/OrderPage', { state: { id } });
    };

    // Filter vendors by search term
    const filteredVendors = vendors.filter(v =>
        v.vendorshopname.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="vendors-page">
            <header className="cart-header">
                <img
                    src={require('../../asset/CocopeatAssests/Arrow Pointing Left.png')}
                    alt={'vendorname'}
                    onClick={() => navigate(-1)}
                />
                <h2 className="fontDG">Vendors</h2>
            </header>

            {loading ? (
                <div className="loader-container">
                    <Oval
                        height={50}
                        width={50}
                        color="#3498db"
                        secondaryColor="#f3f3f3"
                        strokeWidth={5}
                        strokeWidthSecondary={5}
                        ariaLabel="loading"
                    />
                </div>
            ) : (
                <div className="vendor-list">
                    {filteredVendors.length > 0 ? (
                        filteredVendors.map((v) => (
                            <div key={v.vendorId} className="vendor-card">
                                <img src={v.vendorprofile} alt={v.vendorname} className="vendor-logo" />
                                <div className="vendor-details">
                                    <h3 className="fontCC">{v.vendorshopname}</h3>
                                    <p>{v.vendorArea}</p>
                                    <button
                                        className="explore-btn"
                                        onClick={() => handleExplore(v.vendorId)}
                                    >
                                        Explore Products
                                    </button>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="no-results">No vendors found</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default Vendor;
